module.exports = __webpack_public_path__ + "static/media/notebook-icon.2c7c5c7d.svg";